import { differenceInMonths, differenceInDays } from 'date-fns';

/**
 * Returns a human-readable baby age string.
 * Format: "4 months · 12 days" | "2 days old" | "1 year · 3 months"
 */
export function formatBabyAge(dob: Date): string {
  const now = new Date();
  const totalMonths = differenceInMonths(now, dob);

  if (totalMonths < 1) {
    const days = differenceInDays(now, dob);
    return `${days} day${days !== 1 ? 's' : ''} old`;
  }

  if (totalMonths < 24) {
    const baseDate = new Date(dob);
    baseDate.setMonth(baseDate.getMonth() + totalMonths);
    const days = differenceInDays(now, baseDate);
    return days > 0
      ? `${totalMonths} month${totalMonths !== 1 ? 's' : ''} · ${days} day${days !== 1 ? 's' : ''}`
      : `${totalMonths} month${totalMonths !== 1 ? 's' : ''} old`;
  }

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  return months > 0
    ? `${years} year${years !== 1 ? 's' : ''} · ${months} month${months !== 1 ? 's' : ''}`
    : `${years} year${years !== 1 ? 's' : ''} old`;
}
